import styled from 'styled-components';

/**
 * The documents the Young Crew attached. They are links straight to the stored
 * file, so the office downloads them without leaving the report.
 */
export const FileList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li + li {
    margin-top: 6px;
  }

  a {
    text-decoration: underline;
    word-break: break-all;
  }
`;
